import { render, staticRenderFns } from "./List.vue?vue&type=template&id=a04ea804&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04ea804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a04ea804', component.options)
    } else {
      api.reload('a04ea804', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=a04ea804&scoped=true&", function () {
      api.rerender('a04ea804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/adsetprotos/List.vue"
export default component.exports